<div
  [ngClass]="isDealer ? 'dealer-container' : 'container'"
  style="display: block"
>
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.2)"
    size="medium"
    color="#fff"
    type="line-scale"
    [fullScreen]="true"
  ></ngx-spinner>
  <router-outlet></router-outlet>
</div>
